var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SModalCentered", {
    attrs: {
      title: _vm.$t("sModalNewClientCreator.title"),
      isOpen: _vm.isOpen,
      closeModal: _vm.handleClose,
      customProps: { bodyPaddingY: 0, fullWidthFooter: true },
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "mt-3" }, [
              _c("span", {
                staticClass: "modal-span text-subtitle-5",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("sModalNewClientCreator.label.name")
                  ),
                },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.nameRef,
                    expression: "nameRef",
                  },
                ],
                staticClass: "input-form-stemdo mt-2",
                attrs: {
                  id: "newClientName",
                  type: "text",
                  placeholder: _vm
                    .$t("sModalNewClientCreator.placeholder.name")
                    .toString(),
                },
                domProps: { value: _vm.nameRef },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.nameRef = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3" }, [
              _c("span", {
                staticClass: "modal-span text-subtitle-5",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("sModalNewClientCreator.label.surname")
                  ),
                },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.surnameRef,
                    expression: "surnameRef",
                  },
                ],
                staticClass: "input-form-stemdo mt-2",
                attrs: {
                  id: "newClientSurname",
                  type: "text",
                  placeholder: _vm
                    .$t("sModalNewClientCreator.placeholder.surname")
                    .toString(),
                },
                domProps: { value: _vm.surnameRef },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.surnameRef = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3" }, [
              _c("span", {
                staticClass: "modal-span text-subtitle-5",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("sModalNewClientCreator.label.email")
                  ),
                },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.emailRef,
                    expression: "emailRef",
                  },
                ],
                staticClass: "input-form-stemdo mt-2",
                class: { "input-error": _vm.v$.emailRef.$error },
                attrs: {
                  id: "newClientEmail",
                  type: "email",
                  placeholder: _vm
                    .$t("sModalNewClientCreator.placeholder.email")
                    .toString(),
                },
                domProps: { value: _vm.emailRef },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.emailRef = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-2 modal-checkbox-row" },
              [
                _c("v-checkbox", {
                  staticClass: "modal-checkbox-custom",
                  attrs: {
                    label: _vm.$t("sModalNewClientCreator.checkbox"),
                    dense: "",
                    "hide-details": "",
                  },
                  model: {
                    value: _vm.sendWelcomeEmail,
                    callback: function ($$v) {
                      _vm.sendWelcomeEmail = $$v
                    },
                    expression: "sendWelcomeEmail",
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "v-container",
              { staticClass: "p-0" },
              [
                _c(
                  "v-row",
                  { attrs: { "no-gutters": "" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "p-0", attrs: { cols: "12" } },
                      [
                        _c("SButton", {
                          attrs: {
                            action: _vm.handleAdd,
                            btnStyle: "primary",
                            sText: _vm.$t(
                              "sModalNewClientCreator.primaryButtonText"
                            ),
                            disabled: _vm.v$.$invalid,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }